var map = {
	"./de/triangleIcon.png": "+N3/",
	"./en/triangleIcon.png": "8PRW",
	"./es/triangleIcon.png": "ta1c",
	"./fr/triangleIcon.png": "OJ4p",
	"./ja/triangleIcon.png": "aL7Z",
	"./ko/triangleIcon.png": "/C7x",
	"./pt/triangleIcon.png": "ws36",
	"./ru/triangleIcon.png": "ZY3w",
	"./tc/triangleIcon.png": "blK+",
	"./th/triangleIcon.png": "prh9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "O5Zo";